(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'contentSwitchButton', {
            templateUrl:    'app/views/partials/widgets/content-switch-button.html',
            controller:     'ContentSwitcherController',
            controllerAs:   'vm'
        });
})();
